import { createApiService } from "../http";
import { RequestGetAll } from "../types/services-types/http-types";
import { IRegistryFactories } from "../types/services-types/registry-types";

export default class RegistryFactoriesService {
    static apiRegistryCampaniesService = createApiService('/registry-factories')

     static async AddFromExcel(formData: FormData) {
        const response = await this.apiRegistryCampaniesService.post<IRegistryFactories[]>('/add-from-excel', formData)
        return response.data
    }

    static async Add(json: Object) {
        const response = await this.apiRegistryCampaniesService.post<IRegistryFactories>('/add', json)
        return response.data
    }

    static async Update(data: Object) {
        const response = await this.apiRegistryCampaniesService.post<IRegistryFactories>(`/update`, data)
        return response.data
    }

    static async Get(id: number) {
        const response = await this.apiRegistryCampaniesService.get<IRegistryFactories>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: number, page: number) {
        const response = await this.apiRegistryCampaniesService.get<RequestGetAll<IRegistryFactories[]>>('/all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllFilters(sort_date: "DESC" | 'ASC', limit: number, page: number, form: Object) {
        const response = await this.apiRegistryCampaniesService.get<RequestGetAll<IRegistryFactories[]>>('/all-filters', {
            params: {
                ...form,
                sort_date,
                limit,
                page
            }
        })
        return response.data
    }

    static async Delete(id: number) {
        const response = await this.apiRegistryCampaniesService.post<number>(`/delete/${id}`)
        return response.data
    }
}